<template>
  <div class="home">
    <div class="home-header">
       <div class="header-first">
          <div class="first-left">
            <img src="@/assets/image/logo.png" alt="" style="width:100%">
          </div>
          <div class="first-right">
             <ul>
                <li style="margin-left:45px;font-size:16px"><router-link to="/homePage" active-class="active">首页</router-link></li>
                 <li style="margin-top: 2px;">
                  <el-menu :default-active="activeIndex" class="el-menu-demo1" mode="horizontal" @select="handleSelect">
                  <el-submenu index="2">
                    <template slot="title"><router-link to="/train" active-class="active"  style="font-size:16px;position: relative;top: -2px;">产品服务</router-link></template>
                      <el-menu-item index="3-4-1"><router-link to="/train"  style="font-family: Microsoft YaHei;font-weight: 400;color: #666666;" active-class="active2">视频会议</router-link></el-menu-item>
                      <el-menu-item index="3-4-5"><router-link to="/zhineng"  style="font-family: Microsoft YaHei;font-weight: 400;color: #666666;" active-class="active2">智能硬件  </router-link></el-menu-item>
                      <el-menu-item index="3-4-4"><router-link to="/guochanhua"  style="font-family: Microsoft YaHei;font-weight: 400;color: #666666;" active-class="active2">信创国产化 </router-link></el-menu-item>
                      <el-menu-item index="3-4-2"><router-link to="/teaching"  style="font-family: Microsoft YaHei;font-weight: 400;color: #666666;" active-class="active2">会议室客户端</router-link></el-menu-item>
                      <el-menu-item index="3-4-3"><router-link to="/shipinsdk"  style="font-family: Microsoft YaHei;font-weight: 400;color: #666666;" active-class="active2">视频会议SDK</router-link></el-menu-item>
                      <!-- <el-menu-item index="3-4-3"><router-link to="/visit"  style="font-family: Microsoft YaHei;font-weight: 400;color: #666666;" active-class="active2">开放平台</router-link></el-menu-item> -->
                  </el-submenu>
                 </el-menu>
               </li>
          
               <li style="margin-left:75px;width:100px;font-size:16px"><router-link to="/huduan" active-class="active">支持服务</router-link></li>
               <li style="margin-left:10px;width:100px;font-size:16px"><router-link to="/about" active-class="active">关于我们</router-link></li>
             </ul>
          </div>
          <div style="position: absolute;right: 120px;">
            <span style="font-size: 16px;">客服热线:</span><span style="margin-left: 12px;color: rgb(26, 135, 255);">400-672-1386</span>
          </div>
       </div>
    </div>
    <div class="home-img">
         <el-carousel :interval="3000" arrow="always" :style="{'height':  setHeight + 'px' }" v-if=" this.$route.path == '/homePage'" style="margin-top:80px">
            <el-carousel-item v-for="item in getLunbo" :key="item" :style="{'height':  setHeight + 'px' }">
              <img :src="item.url" alt="" :style="{'height':  setHeight + 'px' }">
            </el-carousel-item>
          </el-carousel>
    
          <img src="@/assets/image/6.png" alt=""  v-if="this.$route.path == '/about'" style="width:100%;height:606px;margin-top:80px">
       </div>
       <div>
             <router-view></router-view>
       </div>
      
    <div class="home-footer">
      <div class="footer">
          <div><span style="font-size: 14px;">红杉会议</span></div>
          <div style="margin-top:12px">
             <ul>
               <li v-for="(item,index) in tabs " :key="index"><router-link :to="item.path"  >{{item.name}}</router-link></li>
             </ul>
          </div>
          <div style="margin-top:12px"><span style="font-size:14px;color:#A6A6A6">Copyright © 2017-{{year}} hongshanmeeting.com All Rights Reserved杭州红杉云澎信息技术有限公司 版权所有   <a href="https://beian.miit.gov.cn/" target="_blank" style="font-size:14px;color:#A6A6A6">浙ICP备17012895号-3</a>   <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602013069" style="font-size:14px;color:#A6A6A6">浙公网安备 33010602013069号</a></span></div>
      </div>
    </div>
  </div>
</template>
<script>

    export default {
        data(){
            return {
              setHeight:'',
              current:0,
              offsetTop: 0,
              offsetHeight: 0,
              headerFixed: 0,
              year:'',
              train:'/train',
               getLunbo:[
                 {
                   url:require('@/assets/image/3.png')
                 },
                 {
                   url:require('@/assets/image/8.png')
                 },
                 {
                   url:require('@/assets/image/9.png')
                 },
                 {
                   url:require('@/assets/image/1.png')
                 },
                 {
                   url:require('@/assets/image/2.png')
                 }
               ],
               tabs:[
                 {
                   name:'首页',
                   path:'/homePage'
                 },
                 {
                   name:'产品服务',
                   path:'/train'
                 },
                 {
                   name:'支持服务',
                   path:'/zhichi'
                 },
                  {
                   name:'关于我们',
                   path:'/about'
                 }
               ],
                tabs1:[
                 {
                   name:'产品服务',
                   path:'/product'
                 },
                 {
                   name:'产品服务',
                   path:''
                 },
                 {
                   name:'支持服务',
                   path:''
                 },
            
                  {
                   name:'关于我们',
                   path:'/about'
                 }

               ]
            }
        },
        created(){
          // 获取分辨率
          this.setHeight = (860/1920)* window.screen.width;
          let date = new Date()
          let year = date.getFullYear()
          this.year = year
        },
        methods:{
          gett(index,id){
                 this.current = index
          },
          getsb(){
            console.log(222)
            var arr = document.getElementById('rooms')
            arr.setAttribute("class","active");
          }
        }
    }
</script>
<style>
.el-carousel__arrow--left {
    left: 16px;
    display: none;
}




.el-submenu__title i {
    color: #909399;
    font-size: 16px;
    margin-right: -10px;
}

.el-submenu.is-active .el-submenu__title {
    border-bottom-color: none;
}


/* .el-menu-item:hover{  
  outline: 0 !important;
  color: #fff !important;
  background-color: #0E67DF !important; 
} */
.el-carousel__arrow--right {
    right: 16px;
    display: none;
}

.el-menu--horizontal>.el-submenu .el-submenu__title {
    height: 50px;
    line-height: 50px;
    /* border-bottom: 2px solid transparent; */
    /* color: #909399; */
    font-size: 16px;
    color: #fff;
}
/* .el-submenu :hover{
   background-color: #0E67DF;
} */
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    border-bottom: none;
    color: #303133;
}
.el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
    position: static;
    vertical-align: middle;
    margin-left: 8px;
    margin-top: -3px;
    display: none;
}
  .active1{
    background-color: #1A87FF !important;
    display: block
  }
  .active2{
    display: block;
    color: #1A87FF !important;
  }
  .el-submenu__title {
    margin-left: 0 !important;
    padding-top: 10px;
    font-size: 16px;
    color: #303133;
    padding: 0 20px;
    cursor: pointer;
    box-sizing: border-box;
}
 .el-submenu .el-menu-item {
    height: 30px;
    line-height: 30px;
    min-width: 100px;
    margin-left: 0 !important;
}
.el-menu--popup {
    min-width: 100px!important;
    margin-left: 20px !important;
}
.el-menu.el-menu--horizontal {
    border-bottom: none;
}
  .active{
     color: #0E71EB !important;
  }
  .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title {
    background-color: #FFF;
    float: none;
    height: 36px;
    line-height: 36px;
    padding: 0 10px;
    color: #909399;
    text-align: center;
}
</style>

<style lang="scss" >
*{
  padding: 0;
  margin: 0;
}
  .home{
      .home-header{
          width: 100%;
          height: 80px;
          position: fixed;
          top: 0;
          z-index: 1000;
          background-color: #fff;
          .header-first{
            width: 1240px;
            height: 80px;
            margin:0 auto;
            display: flex;
            align-items: center;
            .first-right{  
              ul{
                display: flex;
                font-size: 16px;
                align-items: center;
                li{
                  width: 50px;
                }
                li a{
                  color: #666666;
                }
              }
            }
            }
          .home-img{
            width: 100%;
            // height:400px;
            margin: 0 auto;
            img{
              width: 100%;
              // min-height: 400px;
            }
          }
      }
      .home-footer{
        width: 100%;
        height: 141px;
        background-color: #292929;
        color: #fff;
        .footer{
            width: 1240px;
            margin:0 auto;
            height: 141px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            ul{
                display: flex;
                font-size: 14px;
                li{
                  margin-right: 45px;
                }
                li a{
                  color: #fff;
                }
              }
        }
      }
  }
</style>